var Textbox = require('../../components/template/Textbox.vue').default
var SubmitButton = require('../../components/template/SubmitButton.vue').default
var ValidationErrors = require('../../components/template/ValidationErrors.vue').default
var OtpTextbox = require('../../components/template/OTPTextbox.vue').default
var AuthFooter = require('../../components/template/Footer.vue').default
import axios from "axios";
import  Vue from  'vue';
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
window.vm = new Vue({
    el: '#loginContainer',
    data () {
        return {
            email_str: null,
            otp_str: null,
            sentOTP: false,
            validationErrors: '',
            resentOTP: false,
            resentMsg: false,
            timeleft: 30
        }
    },
    watch: {
        // otp_str: function(oldValue, newValue) {
        //     console.log('OPT_STR '+ oldValue + " " +newValue);
        // }
    },
    components: {Textbox, SubmitButton, ValidationErrors, OtpTextbox, AuthFooter}, 
    methods: {
        validatePhoneNumber (phone_number){
            let phone_no = parseInt(phone_number)
            if (isNaN(phone_no)){
                return false;
            }
            var regexPhone = /^\+?(\d){7,15}$/;   //regex allows any number between 7 to 15 and allows + at the end
            return regexPhone.test(phone_number);
        },
        validateEmail (email) {
            var re = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return re.test(email);
        },
        getCountryCode( input ) {
            // Set default country code to IN if no real country code is specified
            const defaultCountryCode = input.substr( 0, 1 ) !== '+' ? 'IN' : null;
            let formatted = new libphonenumber.asYouType( defaultCountryCode ).input( input );
            let countryCode = '';
            let withoutCountryCode = formatted;
            
            if ( defaultCountryCode === 'IN' ) {
              countryCode = '+91';
              formatted = '+91 ' + formatted;
            }
            else {
              const parts = formatted.split( ' ' );
              countryCode = parts.length > 1 ? parts.shift() : '';
              withoutCountryCode = parts.join( ' ' );
            }
            
            return {
              formatted,
              withoutCountryCode,
              countryCode,
            }
        },
        resendOTP: async () => {
            if(vm.email_str != null && vm.validateEmail(vm.email_str.toLowerCase().trim())) {
                var email_str = vm.email_str.toLowerCase().trim(),
                isEmail = vm.validateEmail(email_str);

                if (email_str && email_str != "" && slug && isEmail) {
                    var data = {
                        params: {
                            email_id: isEmail ? email_str : null,
                            phone_no: null
                        }
                    }
                    await axios.get('/' + slug + '/apply/sendOTP', data)
                    .then(function(response) {
                        if(response.data.status == 'error'){
                            vm.validationErrors = {'error': response.data.message};
                        } else {
                            vm.sendOTP=false;
                            vm.sentOTP=true;
                            vm.validationErrors = '';
                            //enable resend button after 30 seconds
                            setTimeout(function() {
                                vm.resentOTP = true;
                            }, 30000);
                        }
                    }).catch(function(err) {
                        if(err.response.status == 422) {
                            vm.validationErrors = err.response.data.errors;
                        } 
                        if(err.response.status == 400) {
                            vm.validationErrors = {'error': err.response.data.message};
                        }
                    });
                }
            } else {
                vm.validationErrors = '';
                vm.validationErrors = {'error': 'Invalid Email Id'};
            } 
        },
        sendOTP: async () => {
            if(vm.email_str != null && vm.validateEmail(vm.email_str.toLowerCase().trim())) {
                var email_str = vm.email_str.toLowerCase().trim(),
                isEmail = vm.validateEmail(email_str);

                if (email_str && email_str != "" && slug && isEmail) {
                    var data = {
                        params: {
                            email_id: isEmail ? email_str : null,
                            phone_no: null
                        }
                    }
                    await axios.get('/' + slug + '/apply/sendOTP', data)
                    .then(function(response) {
                        if(response.data.status == 'error'){
                            vm.validationErrors = {'error': response.data.message};
                        } else {
                            document.querySelector('input[name=email_str]').setAttribute('disabled','disabled');
                            vm.sendOTP=false;
                            vm.sentOTP=true;
                            vm.validationErrors = '';
                            setTimeout(function() {
                                vm.resentOTP = true;
                            }, 30000);
                            setInterval(function(){
                                if(vm.timeleft == 0 && Math.sign(vm.timeleft) >= 0){
                                    document.querySelector('.resent-otp-text').innerHTML = "Resend OTP";
                                } 
                                vm.timeleft -= 1;
                            }, 1000);
                        }
                    }).catch(function(err) {
                        if(err.response.status == 422) {
                            vm.validationErrors = err.response.data.errors;
                        } 
                        if(err.response.status == 400) {
                            vm.validationErrors = {'error': err.response.data.message};
                        }
                    });
                }
            } else {
                vm.validationErrors = '';
                if(vm.email_str != null) {
                    vm.validationErrors = {'error': 'Invalid Email Id'};
                } else {
                    vm.validationErrors = {'error': 'Email Id is required'};
                }
            }  
        },
        verifyOTP: async () => {
            if(vm.otp_str != null) {
                var email_str = vm.email_str.toLowerCase().trim(),
                isEmail = vm.validateEmail(email_str),
                otp = vm.otp_str.trim();

                if (email_str != "" && slug && otp != "") {
                    var data = {
                        email_id: isEmail ? email_str : null,
                        phone_no: null,
                        otp: otp
                    }
                    await axios.post('/' + slug + '/apply/verifyOTP', data)
                    .then(function(response) {
                        if(response.data.status == 'error'){
                            vm.validationErrors = {'error': response.data.message};
                        } else {
                            var routeUrl = "/" + slug + "/apply",
                                url = window.location.origin + routeUrl;
                            window.location.href = url;
                        }
                    }).catch(function(err) {
                        if(err.response.status == 400) {
                            vm.validationErrors = {'error': err.response.data.message};
                        } 
                    });
                }
            } else {
                vm.validationErrors = {'error': 'Please enter valid OTP'};
            }   
        }
    }
});